import { REFERRAL_STATUS } from 'Enum/medicalReferrals';

export interface IAdvancedSearchState {
  requestState: number | null;
  requestNumber: number | null;
  providerName: string | null;
  dateRange: {
    start: Date | null;
    end: Date | null;
    isYear: boolean;
  };
  requestValidation: {
    presentValidated: boolean;
    pastValidated: boolean;
    futureValidated: boolean;
  };
  activeSearch: {
    text: boolean;
    advanced: boolean;
  };
  supplierNames: string[];
  dateMinMaxRange: {
    min: Date;
    max: Date;
  };
  requestNumberList: string[];
}

export function AdvancedSearchReducer(
  state: IAdvancedSearchState,
  action: any
) {
  switch (action.type) {
    case 'SEARCH_FIELDS_DATA_INITIALIZATION': {
      const supplierNames = action.payload.value.providersList;
      const dateMinMaxRange = action.payload.value.dateMinMaxRange;
      const tempCombinedReferralList = [
        ...action.payload.value.referrals.validReferrals,
        ...action.payload.value.referrals.otherReferrals,
      ];
      const requestNumberList = [];
      for (let i = 0; i < tempCombinedReferralList.length; i++)
        requestNumberList.push(tempCombinedReferralList[i].requestNumber);
      return { ...state, supplierNames, dateMinMaxRange, requestNumberList };
    }
    case 'REQUEST_STATE': {
      const requestState = RequestStateStringToCodeNumber(
        action.payload.value,
        action.payload.options
      );
      return { ...state, requestState };
    }
    case 'REQUEST_NUMBER': {
      const requestNumber = action.payload.value;
      return { ...state, requestNumber };
    }
    case 'REQUEST_PROVIDER': {
      const providerName = action.payload.value;
      return { ...state, providerName };
    }
    case 'REQUEST_DATE_VALIDATION': {
      state.requestValidation.futureValidated = false;
      state.requestValidation.pastValidated = false;
      state.requestValidation.presentValidated = false;

      const requestValidation = state.requestValidation;

      action.payload.value.forEach((value: number) => {
        switch (value) {
          case 1: {
            requestValidation.presentValidated = true;
            break;
          }
          case 2: {
            requestValidation.pastValidated = true;
            break;
          }
          case 3: {
            requestValidation.futureValidated = true;
            break;
          }
          default:
            break;
        }
      });
      return { ...state, requestValidation };
    }
    case 'REQUEST_DATE_RANGE': {
      const dateRange = {
        start: action.payload.value.start,
        end: action.payload.value.end,
        isYear: action.payload.value.isYear,
      };
      return { ...state, dateRange };
    }
    case 'ACTIVE_SEARCH_TEXT': {
      const activeSearch = {
        text: action.payload.value,
        advanced: state.activeSearch.advanced,
      };
      return { ...state, activeSearch };
    }
    case 'ACTIVE_SEARCH_ADVANCED': {
      const activeSearch = {
        text: false,
        advanced: action.payload.value,
      };
      return { ...state, activeSearch };
    }
    case 'REMOVE_SEARCH_OPTION': {
      return RemoveSearchOption(
        state,
        action.payload.searchValueID,
        action.payload.subValueFieldID
      );
    }
    case 'RESET': {
      return {
        ...state,
        requestNumber: null,
        requestState: null,
        providerName: null,
        requestValidation: {
          ...state.requestValidation,
          presentValidated: false,
          pastValidated: false,
          futureValidated: false,
        },
        dateRange: {
          start: null,
          end: null,
          isYear: false,
        },
        activeSearch: {
          text: false,
          advanced: false,
        },
        supplierNames: state.supplierNames,
      };
    }
  }
  return state;
}

/**
 * Given a string request state returns the corresponding numeric status code.
 * @param state Current request state string.
 * @param options Dictionary alphabet state options.
 * @returns Status code.
 */
function RequestStateStringToCodeNumber(state: string, options: any) {
  switch (state) {
    case options.approved: {
      return REFERRAL_STATUS.APPROVED;
    }
    case options.review: {
      return REFERRAL_STATUS.UNDER_REVIEW;
    }
    case options.denied: {
      return REFERRAL_STATUS.REJECTED;
    }
    case options.opened: {
      return REFERRAL_STATUS.OPENED_IN_SYSTEM;
    }
    case options.cancelled: {
      return REFERRAL_STATUS.REJECTED;
    }
  }
  return null;
}

enum subSearchRequestValidationFieldID {
  pastValidated = 1,
  presentValidated = 2,
  futureValidated = 3,
}

/**
 * Given an ID search option removes it from the advanced search.
 * @param state Advanced Search State object.
 * @param searchValueIDtoRemove ID search option number.
 * @returns Advanced Search State object.
 */
function RemoveSearchOption(
  state: IAdvancedSearchState,
  searchValueIDtoRemove: number,
  subSearchValueFieldID: number
) {
  switch (searchValueIDtoRemove) {
    case 1: {
      const requestState = null;
      return { ...state, requestState };
    }
    case 2: {
      const requestNumber = null;
      return { ...state, requestNumber };
    }
    case 3: {
      const providerName = null;
      return { ...state, providerName };
    }
    case 4: {
      const dateRange = { ...state.dateRange };
      if (subSearchValueFieldID === 1) dateRange.start = null;
      // 1 stands for start date.
      else dateRange.end = null;
      return { ...state, dateRange };
    }
    case 5: {
      const requestValidation = { ...state.requestValidation };
      if (
        subSearchValueFieldID ===
        subSearchRequestValidationFieldID.pastValidated
      )
        requestValidation.pastValidated = false;
      if (
        subSearchValueFieldID ===
        subSearchRequestValidationFieldID.presentValidated
      )
        requestValidation.presentValidated = false;
      if (
        subSearchValueFieldID ===
        subSearchRequestValidationFieldID.futureValidated
      )
        requestValidation.futureValidated = false;
      return { ...state, requestValidation };
    }
    default:
      return state;
  }
}
